import { SignUpForm } from '@components/Auth/SignUpForm';

export const SignUpPage = () => {
  return <SignUpForm />;
};
